import type { CPBreadcrumbItem } from '@ui/components/types/breadcrumb.types'

/**
 * Truncates the trail to **Home → Communities → group name** for `communities-groups-*` routes.
 * Drops tab labels (Discussion, Members, …), channel names, post titles, etc.
 *
 * Preconditions: registry trail with at least three segments (home, communities, generic group crumb).
 */
export function injectCommunitiesGroupNameAsFinalSegment(
  items: CPBreadcrumbItem[],
  groupName: string,
  onNavigateToGroupHome: () => void
): CPBreadcrumbItem[] {
  if (items.length < 3) return items
  return [...items.slice(0, 2), { label: groupName, onClick: onNavigateToGroupHome }]
}
